(() => {
 function init(){
  const headerCountdown = document.querySelector('wp-sale-countdown[data-placement="header"] .section-announcement');
  document.body.style.setProperty('--wholeopolis-header-height', (headerCountdown?.getBoundingClientRect().height || 0)+'px');
  document.body.style.setProperty('--wholeopolis-message-height', (document.querySelector('[data-message-announcement]')?.getBoundingClientRect().height || 0)+'px');
  document.querySelectorAll('[data-message-announcement]').forEach(el=>{
   if(el.dataset.heightReady)return;el.dataset.heightReady='true';
   new ResizeObserver(()=>document.body.style.setProperty('--wholeopolis-message-height',el.getBoundingClientRect().height+'px')).observe(el);
  });
  document.querySelectorAll('wp-sale-countdown[data-placement="header"] .section-announcement').forEach(el=>{
   if(el.dataset.heightReady)return;el.dataset.heightReady='true';
   new ResizeObserver(()=>document.body.style.setProperty('--wholeopolis-header-height',el.getBoundingClientRect().height+'px')).observe(el);
  });
  document.querySelectorAll('[data-product-section]').forEach(section=>{
   const gallery=section.querySelector('.product-gallery');
   if(!gallery?.__galleryInstance||gallery.dataset.initializedVariant)return;
   gallery.dataset.initializedVariant='true';
   const id=new URLSearchParams(location.search).get('variant');
   const variant=JSON.parse(section.querySelector('[data-product-json]').textContent).variants.find(v=>String(v.id)===id);
   if(variant)gallery.__galleryInstance.updateWithVariant({variantId:variant.id,mediaId:variant.featured_media?.id,image:variant.featured_image});
  });
 }
 document.addEventListener('shopify:section:unload',()=>requestAnimationFrame(init));document.addEventListener('DOMContentLoaded',init);document.addEventListener('shopify:section:load',init);if(document.readyState!=='loading')init();
})();
(() => {
  if (window.studioPromotionActionsReady) return;
  window.studioPromotionActionsReady = true;
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-klaviyo-open], [data-cart-bundle-jump]');
    if (!trigger) return;
    event.preventDefault();
    if (trigger.hasAttribute('data-cart-bundle-jump')) {
      const cart = trigger.closest('#CartDialog');
      const area = cart?.querySelector('.cart-scroll-area');
      const bundle = area?.querySelector('pair-bundle');
      if (!bundle || !area) return;
      bundle.setAttribute('tabindex', '-1');
      bundle.focus({preventScroll:true});
      area.scrollTo({top:area.scrollTop + bundle.getBoundingClientRect().top - area.getBoundingClientRect().top - 8, behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      return;
    }
    const formId = trigger.dataset.klaviyoOpen;
    if (!formId) return;
    const cart = trigger.closest('dialog');
    if (cart?.open) cart.close();
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(['openForm', formId]);
  });
  document.addEventListener('keydown', event => {
    const trigger = event.target.closest('[data-cart-bundle-jump][role="button"]');
    if (trigger && (event.key === 'Enter' || event.key === ' ')) {
      event.preventDefault(); trigger.click();
    }
  });
})();